export default{
    contIncrease(state,num){
        console.log(num)
        state.count+=num
    },
    onlogin(state,v){
        state.userInfo=v
    },
    loginOut(state){
        state.userInfo=''
    },
    setMemeberInfo(state,v){
        state.userState=v.userStatus
        state.viple
    }
}


// WEBPACK FOOTER //
// ./src/store/modules/mutations.js